import React from 'react';
import './StackedAvatars.scss';
import ChatUserAvatar from './ChatUserAvatar';
import VerifiedShieldBadge from '../common/VerifiedShieldBadge/VerifiedShieldBadge';

interface Participant {
  userId: string;
  name: string;
  avatar: string | null;
  role: string;
  marketplaceRole?: 'BUYER' | 'SELLER' | null;
  isOriginal?: boolean;
  isSelf: boolean;
  verified?: boolean;
}

interface StackedAvatarsProps {
  participants: Participant[];
  maxVisible?: number;
  size?: number;
  onClick?: () => void;
}

const StackedAvatars: React.FC<StackedAvatarsProps> = ({
  participants,
  maxVisible = 3,
  size = 36,
  onClick
}) => {
  // Show non-self participants first, then self
  const sorted = [...participants].sort((a, b) => {
    if (a.isSelf && !b.isSelf) return 1;
    if (!a.isSelf && b.isSelf) return -1;
    return 0;
  });

  const visible = sorted.slice(0, maxVisible);
  const overflow = sorted.length - maxVisible;

  return (
    <div
      className={`stacked-avatars ${onClick ? 'stacked-avatars--clickable' : ''}`}
      onClick={onClick}
      style={{ height: size }}
    >
      {visible.map((participant, index) => (
        <div
          key={participant.userId}
          className="stacked-avatars__item"
          style={{
            width: size,
            height: size,
            zIndex: visible.length - index,
            marginLeft: index === 0 ? 0 : -(size * 0.3),
          }}
        >
          {participant.avatar ? (
            <img
              src={participant.avatar}
              alt={participant.name}
              className="stacked-avatars__image"
            />
          ) : (
            <ChatUserAvatar
              name={participant.name}
              height={size}
              width={size}
              verified={!!participant.verified}
            />
          )}
          {participant.avatar && participant.verified && (
            <VerifiedShieldBadge size={size >= 64 ? 'lg' : size >= 36 ? 'md' : 'sm'} />
          )}
        </div>
      ))}
      {overflow > 0 && (
        <div
          className="stacked-avatars__overflow"
          style={{
            width: size,
            height: size,
            marginLeft: -(size * 0.3),
            fontSize: size * 0.35,
          }}
        >
          +{overflow}
        </div>
      )}
    </div>
  );
};

export default StackedAvatars;
